/* globals Knitiv */

export default class KformElementController {
	/* @ngInject */
	/**
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').IRootElementService} $element
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($compile, $element, $rootScope, $sce, $scope, $timeout) {
		this.$compile = $compile;
		this.$element = $element;
		this.$rootScope = $rootScope;
		this.$sce = $sce;
		this.$scope = $scope;
		this.$timeout = $timeout;

		/** @type {any} */
		this.component = undefined;

		/** @type {string | undefined} */
		this.componentId = undefined;

		/** @type {any} */
		this.data = undefined;

		/** @type {any} */
		this.index = 0;

		/** @type {boolean | undefined} */
		this.readOnly = undefined;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {?import('~/components/kform/component/kform-component.controller').default} */
		this.kformComponentController = null;
		this.template = undefined;
		this.disableComponents = [];
	}

	isAdmin() {
		return this.$rootScope.context?.profil.admin ?? false;
	}

	isDescriptionHTML() {
		return (this.component?.description?.startsWith('<'));
	}

	$onInit() {
		this.$scope = this.kformComponentController?.$scope;
		if (this.kformComponentController?.template) {
			const template = typeof this.kformComponentController.template === 'function'
				? this.kformComponentController.template(this.$scope)
				: this.kformComponentController.template;
			this.template = this.$sce.trustAsHtml(template);
		}
		this.$scope.componentId = this.component.key;
		this.$scope.$emit('formElementRender', this.$element);

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.mincard = (modelValue, viewValue) => {
				const data = modelValue || viewValue;
				if (
					!data
					|| data[this.component.key] === undefined
					|| !this.component.validate?.card
					|| this.component.validate.card.from <= 1
				) {
					return true;
				}

				if (!Array.isArray(data[this.component.key])) {
					data[this.component.key] = [];
				}

				const filteredData = data[this.component.key].filter(
					(/** @type {any} */ value) => !!value && Object.keys(value).length > 0 && (value.kid || value.name),
				);
				return filteredData.length >= this.component.validate.card.from;
			}
			this.$scope.$watch('data[component.key]', () => {
				this.ngModelCtrl?.$validate();
			}, true);

			this.ngModelCtrl.$validators.maxcard = (modelValue, viewValue) => {
				const data = modelValue || viewValue;
				if (
					!data
					|| data[this.component.key] === undefined
					|| !this.component.validate?.card
				) {
					return true;
				}
				if (!Array.isArray(data[this.component.key])) {
					data[this.component.key] = [];
				}
				const filteredData = data[this.component.key].filter(
					(/** @type {any} */ value) => !!value && Object.keys(value).length > 0 && (value.kid || value.name),
				);
				return filteredData.length <= this.component.validate.card.to;
			}
			this.$scope.$watch('data[component.key]', () => {
				this.ngModelCtrl?.$validate();
			}, true);
		}
	}
}
